import Filter from "./Filter/Filter";

const Songs = () => {
  return (
    <div>
      <div className="">
        <h2>Songs</h2>
      </div>
      <div className="">
        <Filter />
      </div>
    </div>
  );
};

export default Songs;
